export enum BellSchedulesListTableColumns {
  SELECT = 'Select',
  NAME = 'Name',
  DESCRIPTION = 'Description',
  ACTIONS = 'Actions',
}
